import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { MapHeatChart } from 'gnos-charts'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import config from '../../../../../../../../../../../config'

import { LOCALE_PREFIX } from './constants'

import Summary from '../Summary'
import ToggleButton from '../../../../../../../../../../../components/ToggleButton'
import CloseButton from '../../../../../../../../../../../components/CloseButton'
import LineBanner from '../../../../../../../../../../../components/Banners/components/LineBanner'

import hocConnect from './hocConnect'
import hocDialog from '../../../../../../../../../../../services/dialog/hocDialog'

import './style.scss'

@injectIntl
@hocConnect
@hocDialog
export default class DistributionTab extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        isPaidVersion: PropTypes.bool.isRequired,
        loadDataTable: PropTypes.func.isRequired,
        openDialog: PropTypes.func.isRequired,
        saveCustomData: PropTypes.func.isRequired,
        transformedData: PropTypes.object,
    }

    onChartToggle = (toggledValue) => {
        const { saveCustomData } = this.props

        saveCustomData({ restrictionSwitch: toggledValue })
    }

    onDataTableToggle = (toggledValue) => {
        const { saveCustomData } = this.props

        saveCustomData({ dataTableSwitch: toggledValue })
    }

    onDataTableClose = () => {
        const { saveCustomData } = this.props

        saveCustomData({ dataTableSwitch: false })
    }

    onMoreClick = () => {
        window.open('https://www.bisnode.cz/cz/data-o-nemovitostech/', '_blank')
    }

    onContactClick = () => {
        const { openDialog } = this.props

        openDialog('infoPaidData')
    }

    onDataTableChange = (tableState) => {
        const { id, loadDataTable } = this.props

        loadDataTable(id, tableState.sorted)
    }

    createHeatMapLabel = (area) => area.label

    createHeatMapBalloon = (area) => area.balloonText

    renderCellValue = ({ value }) => value || 0

    renderRestrictionCell = ({ value, original }) => {
        const { intl } = this.props

        const total = _.get(original, 'total', 0)
        const textId = `${LOCALE_PREFIX}.table.${value > 0 ? 'yes' : 'no'}`

        return (
            <div className={'restrictionsCell'}>
                {total > 0 ? intl.formatMessage({ id: textId }, { count: value }) : '-'}
            </div>
        )
    }

    renderSummary = () => {
        const { transformedData } = this.props

        const summary = _.get(transformedData, 'summary', null)

        if (!summary) return null

        return <Summary total={summary.total || 0} restrictions={summary.restrictions || 0} />
    }

    renderChart = () => {
        const { customData, transformedData, intl } = this.props

        const chartData = _.get(transformedData, 'chart', null)

        if (!chartData) return null

        const chartHeight = 500
        const restrictionSwitch = _.get(customData, 'restrictionSwitch', false)
        const dataTableSwitch = _.get(customData, 'dataTableSwitch', true)

        const color = restrictionSwitch ? '#29abe2' : '#ed8080'
        const data = restrictionSwitch ? chartData.total : chartData.restriction

        return (
            <div className={'chart-wrap'}>
                <div className={'chart-header'}>
                    <div className={'color'}>
                        <div className={'text'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.chart.switch.color.left`} />
                        </div>
                        <div className={'toggle'}>
                            <ToggleButton active={restrictionSwitch} onClickHandler={this.onChartToggle} arrows />
                        </div>
                        <div className={'text'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.chart.switch.color.right`} />
                        </div>
                    </div>
                    <div className={'data-table'}>
                        <div className={'text'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.chart.switch.table`} />
                        </div>
                        <div className={'toggle'}>
                            <ToggleButton
                                active={dataTableSwitch}
                                textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.chart.switch.yes` })}
                                textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.chart.switch.no` })}
                                onClickHandler={this.onDataTableToggle}
                                inactiveGreyBackground
                                inactiveGreyBorder
                            />
                        </div>
                    </div>
                </div>
                <div className={'chart'}>
                    <MapHeatChart
                        style={{
                            width: '100%',
                            height: `${chartHeight}px`,
                            maxWidth: `${chartHeight * 2}px`,
                            margin: '0 auto',
                        }}
                        map={'czech'}
                        dataProvider={data}
                        colorEnd={data.zeroValues ? '#ffffff' : color}
                        label={this.createHeatMapLabel}
                        createBalloonText={this.createHeatMapBalloon}
                    />
                </div>
            </div>
        )
    }

    renderDataTable = () => {
        const { id, block, customData, transformedData, intl } = this.props

        const summary = _.get(transformedData, 'summary', null)
        const dataTableSwitch = _.get(customData, 'dataTableSwitch', true)

        if (!summary || !dataTableSwitch) return null

        const table = _.get(customData, 'distribution.table', {})

        const tableData = _.get(table, 'data', [])
        const tableSortAvailableColumns = _.get(table, 'sort.availableColumns', [])
        const tableSortSorted = _.get(table, 'sort.sorted', [])

        const tableIsLoading = _.get(customData, 'distribution.isLoading', false)

        return (
            <div className={'data-table-wrap'}>
                <div className={'data-table-title'}>
                    <div className={'text'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.table.title`} />
                    </div>
                    <CloseButton size={20} onClick={this.onDataTableClose} />
                </div>
                <FilterTable
                    id={`${config.modules.report.key}_${id}_${block}_filterTable`}
                    loading={tableIsLoading}
                    data={tableData}
                    settings={{
                        sorted: tableSortSorted,
                        pagination: {
                            totalRows: _.size(tableData),
                        },
                    }}
                    columnsDefinition={[
                        {
                            accessor: 'regionName',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.table.header.regionName` }),
                            width: 180,
                            sortable: _.includes(tableSortAvailableColumns, 'regionName'),
                        },
                        {
                            accessor: 'total',
                            Header: intl.formatMessage(
                                { id: `${LOCALE_PREFIX}.table.header.total` },
                                { count: summary.total }
                            ),
                            Cell: this.renderCellValue,
                            sortable: _.includes(tableSortAvailableColumns, 'total'),
                        },
                        {
                            accessor: 'parcels',
                            Header: intl.formatMessage(
                                { id: `${LOCALE_PREFIX}.table.header.parcels` },
                                { count: summary.parcels }
                            ),
                            Cell: this.renderCellValue,
                            sortable: _.includes(tableSortAvailableColumns, 'parcels'),
                        },
                        {
                            accessor: 'buildings',
                            Header: intl.formatMessage(
                                { id: `${LOCALE_PREFIX}.table.header.buildings` },
                                { count: summary.buildings }
                            ),
                            Cell: this.renderCellValue,
                            sortable: _.includes(tableSortAvailableColumns, 'buildings'),
                        },
                        {
                            accessor: 'units',
                            Header: intl.formatMessage(
                                { id: `${LOCALE_PREFIX}.table.header.units` },
                                { count: summary.units }
                            ),
                            Cell: this.renderCellValue,
                            sortable: _.includes(tableSortAvailableColumns, 'units'),
                        },
                        {
                            accessor: 'restrictions',
                            Header: intl.formatMessage(
                                { id: `${LOCALE_PREFIX}.table.header.restrictions` },
                                { count: summary.restrictions }
                            ),
                            Cell: this.renderRestrictionCell,
                            sortable: _.includes(tableSortAvailableColumns, 'restrictions'),
                        },
                    ]}
                    onTableChange={this.onDataTableChange}
                    showPagination={false}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                    }}
                />
            </div>
        )
    }

    renderLineBanner = () => {
        const { isPaidVersion, intl } = this.props

        if (isPaidVersion) return null

        return (
            <div className={'real-estates-line-banner'}>
                <LineBanner
                    id={'real-estate-line'}
                    text={intl.formatMessage({ id: `${LOCALE_PREFIX}.banner.text` })}
                    buttonsSetting={[
                        {
                            text: intl.formatMessage({ id: `${LOCALE_PREFIX}.banner.button.more` }),
                            onClick: this.onMoreClick,
                        },
                        {
                            text: intl.formatMessage({ id: `${LOCALE_PREFIX}.banner.button.contact` }),
                            onClick: this.onContactClick,
                        },
                    ]}
                    noMoreShowButton={false}
                />
            </div>
        )
    }

    render() {
        return (
            <div className={'distribution-tab'}>
                {this.renderSummary()}
                {this.renderChart()}
                {this.renderDataTable()}
                {this.renderLineBanner()}
            </div>
        )
    }
}
